var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H5.5L7 8M7 8L12 28H38L43 8H7Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 38C13.6569 38 15 36.6569 15 35C15 33.3431 13.6569 32 12 32C10.3431 32 9 33.3431 9 35C9 36.6569 10.3431 38 12 38Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38C39.6569 38 41 36.6569 41 35C41 33.3431 39.6569 32 38 32C36.3431 32 35 33.3431 35 35C35 36.6569 36.3431 38 38 38Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopBlack);
export default __webpack_public_path__ + "static/media/shop_black.618be2937927aa78933bfc4204332f55.svg";
export { ForwardRef as ReactComponent };